import EFPicture from 'elem/compCommon/EFPicture';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_220w_double');
    return (
        <div className="sp-220-double-C">
            <div className="info-box">
                <p className="title">{t('C_title')}</p>
                <p className="desc">{t('C_desc')}</p>
            </div>
            <div className="img-box">
                <EFPicture
                    src="/responsive/picture/solar-panel-220w-double/3.jpg"
                    srcPad="/responsive/picture/solar-panel-220w-double/3_768.jpg"
                    srcMobile="/responsive/picture/solar-panel-220w-double/3_768.jpg"
                    alt={t('C_title')}
                />
            </div>
        </div>
    );
}
